/* eslint-disable react/display-name */
import { forwardRef } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

const BlogCategoryBtn = forwardRef(({ onClick, btnText, isActive }, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      className={classNames(
        {
          "border-b-[2px] text-primary": isActive,
        },
        "cursor-pointer whitespace-nowrap border-primary px-2 py-5 text-[0.875rem] font-semibold text-grayDisplay-400 hover:text-primary lg:text-base"
      )}
    >
      {btnText}
    </button>
  );
});

BlogCategoryBtn.propTypes = {
  onClick: PropTypes.func,
  btnText: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
};

export default BlogCategoryBtn;
